import { render, staticRenderFns } from "./the-price.vue?vue&type=template&id=76273092"
import script from "./the-price.vue?vue&type=script&lang=js"
export * from "./the-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports